var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPromptusToken(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "promptus-token",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.39,
    height: 30.39,
    viewBox: "0 0 30.39 30.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M15.195,0A15.2,15.2,0,1,1,0,15.195,15.195,15.195,0,0,1,15.195,0",
    fill: "#fabe2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M73.509,15.2A15.237,15.237,0,0,0,58.314,0v30.39A15.237,15.237,0,0,0,73.509,15.2",
    transform: "translate(-43.119 -0.001)",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M25.469,13.895A11.574,11.574,0,1,1,13.895,25.469,11.574,11.574,0,0,1,25.469,13.895",
    transform: "translate(-10.274 -10.274)",
    fill: "#fed843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M69.888,25.47A11.588,11.588,0,0,0,58.314,13.9V37.044A11.588,11.588,0,0,0,69.888,25.47",
    transform: "translate(-43.119 -10.275)",
    fill: "#fabe2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M4.063,9.066c.375,1.422.672,2.715,1.062,3.98.506,1.649.436,2.2-.5,2.611-1.544.687-2.847.428-3.4-1.005A15.985,15.985,0,0,1,.145,10C-.046,7.1.034,4.175,0,1.09A28.226,28.226,0,0,1,3.762.219,12.919,12.919,0,0,1,8.75.277,3.943,3.943,0,0,1,10.72,6.489,4.967,4.967,0,0,1,7.262,8.537c-.99.1-1.968.321-3.2.528M3.327,3.237,3.9,7.059c1.165-.42,2.237-.727,3.238-1.189A1.479,1.479,0,0,0,7.777,3.75,2.14,2.14,0,0,0,6.21,2.8a14.268,14.268,0,0,0-2.884.437",
    transform: "translate(11.373 7.287) rotate(9)",
    fill: "#b7363a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromptusToken);
export default __webpack_public_path__ + "static/media/promptus-token.a7325d2a2050f70b4221e1b2509b4b9f.svg";
export { ForwardRef as ReactComponent };